import { render } from "./CpsButton.vue?vue&type=template&id=4444e25b&scoped=true&ts=true"
import script from "./CpsButton.vue?vue&type=script&lang=ts"
export * from "./CpsButton.vue?vue&type=script&lang=ts"

import "./CpsButton.vue?vue&type=style&index=0&id=4444e25b&scoped=true&lang=css"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4444e25b"]])

export default __exports__